import React from 'react';
import moment from 'moment-timezone';
import { Spinner } from 'reactstrap'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';

function CampaignCard({ 
          campaign, 
          click, 
          classes, 
          boxiPrimary, 
          selected,
          id,
          campaignActiveTrucks,
          index,
          loadingTrucks,
          clientInpersonate
 }) {
  const targetDate = moment.tz(campaign.endDate, 'America/Los_Angeles');

  // Current date
  const currentDate = moment.tz('America/Los_Angeles');
  // Calculate the difference in days
  const daysRemaining = targetDate.diff(currentDate, 'days');
  const startDate = moment(campaign.startDate).tz('America/Los_Angeles');
  const endDate = moment(campaign.endDate).tz('America/Los_Angeles');
  // Create formatted date strings
  const formattedStartDate = startDate.format('Do MMM YYYY');
  const formattedEndDate = endDate.format('Do MMM YYYY');
  if(formattedStartDate === formattedEndDate){
    return <></>
  }

  const sumOfArrayLengths = Number(campaignActiveTrucks?.total_sum) ?   campaignActiveTrucks?.total_sum : 0;
  return (
    <div className={`${classes.campaign_card} ${id == selected ? classes.campaign_card_active: ''}`} onClick={click}>
      <div className={classes.campaign_card_header}>
        <div>
          <p className={classes.campaign_card_heading} style={clientInpersonate ? { fontSize: '12px'} : {}}>
            {campaign?.name}
          </p>
          <span className={classes.campaign_card_scheule}>{formattedStartDate} to {formattedEndDate}</span>
        </div>
        <p className={classes.campaign_card_status}>Active</p>
      </div>
      <div className={classes.campaign_card_footer}>
        <div style={{ flex: '0 0 60%'}}>{daysRemaining > 0 ? daysRemaining: 0} {daysRemaining > 0 && daysRemaining === 1 ? 'day': daysRemaining < 0 ? 'day': 'days'} remaining</div>
        {/* <p className={classes.campaign_card_vehicles}> */}
          <div style={{flex: '0 0 5%'}}>
            {loadingTrucks ? (
              <Spinner
               style={{ width: "1.2rem", height: "1.2rem" }}
               type="border"
               color={'#B93A76'}
               className="spinner-border-sm"
             />
            ) : (
              <LocalShippingOutlinedIcon style={{
              color: boxiPrimary,
              width: '20px',
              height: '20px',
              }} />
            )}
          </div>

          <div style={{flex: '0 0 25%'}}>
            {Number(sumOfArrayLengths) > 0 ? Number(sumOfArrayLengths) : 0} {Number(sumOfArrayLengths) > 1 ? 'trucks': 'truck'}
          </div>
        {/* </p> */}
      </div>
    </div>
  );
}

export default CampaignCard;